module.exports = __webpack_public_path__ + "img/n6.246c7e90.jpg";